/**
 * Custom events dispatched during batch transfer processing.
 */

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();export interface BatchTransferErrorEventDetail {
  message: string;
}

export interface BatchTransferPartialEventDetail {
  queuedCount: number;
}

export interface BatchTransferStartEventDetail {
  showToast?: boolean;
  fromEntity?: boolean;
  totalPayments?: number;
}

export const BATCH_TRANSFER_ERROR_EVENT = 'batch-transfer-error';
export const BATCH_TRANSFER_COMPLETED_EVENT = 'batch-transfer-completed';
export const BATCH_TRANSFER_PARTIAL_EVENT = 'batch-transfer-partial';
